module.exports = __webpack_public_path__ + "img/PL08126.8330f8a1.png";